export default "__VITE_ASSET__Biiax87M__"